import { useEffect, useState } from 'react';
import landingServive from '../../services/landingService';
import { Button } from '@mui/material';
import check from '../../assets/icons/check.svg';
import { useTranslation } from 'react-i18next';
import { SubscriptionList } from '../../types/subscription';

const TariffArea = () => {
  const { t } = useTranslation();
  const [subscriptions, setSubscriptions] = useState<SubscriptionList>([]);

  useEffect(() => {
    const fetchSubscriptions = async () => {
      try {
        const response = await landingServive.getSubscriptions();
        setSubscriptions(response);
      } catch (error) {
        console.error('Error fetching subscriptions:', error);
      }
    };

    fetchSubscriptions();
  }, []);

  return (
    <div className="price-section" id="tariffs">
      <h2 className="small-title">{t('uniqueTariffs')}</h2>
      <div className="area">
        {subscriptions.map((subscription) => (
          <div className="price-card" key={subscription.id}>
            <div className="header">
              <div className="price-name"></div>
              <div className="price-summ">
                {subscription.price} UZS
                <p className="price-summ-two">/ {subscription.limit} документ</p>
              </div>
            </div>
            <div className="text">
              <div className="check-icon-box">
                <img src={check} alt="check" className="check-icon" />
              </div>
              <p style={{ fontSize: 13, lineHeight: 1.6, marginBottom: 10 }}>
                {subscription.name.uz}
              </p>
            </div>
            <div className="text">
              <div className="check-icon-box">
                <img src={check} alt="check" className="check-icon" />
              </div>
              <p style={{ fontSize: 13, lineHeight: 1.6, marginBottom: 10 }}>
                {subscription.description.uz}
              </p>
            </div>

            <div className="line"></div>
            <Button className="button" variant="outlined" color="inherit">
              {t('buy')}
            </Button>
          </div>
        ))}
      </div>
    </div>
  );
};

export default TariffArea;
